import { render, staticRenderFns } from "./appCheckbox.vue?vue&type=template&id=2a33c7ee"
import script from "./appCheckbox.vue?vue&type=script&lang=js"
export * from "./appCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports